module.exports = __webpack_public_path__ + "img/friends.38336d4.svg";